/* eslint-disable import/no-duplicates */
import { format } from "date-fns";

export const formatDate = (dateToFormat: Date) => {
  const newDate = format(new Date(dateToFormat), "dd.MM.yyyy");

  return newDate;
};
